import { memoryTiming } from "../core/director/timing";
import type { WishItem } from "../models/contracts";

export { memoryTiming };

export function calculateWishReadingDuration(text: string): number {
  const words = text.trim().split(/\s+/).filter(Boolean).length;
  const estimated = 4_500 + words * 310 + Math.max(0, text.length - 120) * 16;
  return Math.max(memoryTiming.wishReadingMinMs, Math.min(memoryTiming.wishReadingMaxMs, estimated));
}

export function galleryFocusDuration(item: { width: number | null; height: number | null; isHighlighted: boolean; mediaType: string }): number {
  const pixels = (item.width ?? 0) * (item.height ?? 0);
  const importance = item.isHighlighted ? 1_800 : pixels >= 2_000_000 ? 900 : 0;
  const video = item.mediaType.toLowerCase() === "video" ? 1_000 : 0;
  return Math.min(memoryTiming.galleryFocusMaxMs, memoryTiming.galleryFocusMinMs + importance + video);
}

export function paginateWish(wish: WishItem, maxCharacters = 240): string[] {
  const paragraphs = wish.text.trim().split(/\n{2,}/).map(value => value.trim()).filter(Boolean);
  const pages: string[] = [];
  let page = "";
  for (const paragraph of paragraphs.length ? paragraphs : [wish.text.trim()]) {
    for (const sentence of paragraph.split(/(?<=[.!?…])\s+/)) {
      if (page && `${page} ${sentence}`.length > maxCharacters) { pages.push(page); page = sentence; }
      else page = page ? `${page} ${sentence}` : sentence;
    }
    if (page.length > maxCharacters * .65) { pages.push(page); page = ""; }
  }
  if (page) pages.push(page);
  return pages.length ? pages.slice(0, 4) : [""];
}
